import { ICD10_IPDN_TREE_FILTER_URL, ICD10_IPDN_TREE_URL, ICD10_TREE_FILTER_URL, ICD10_TREE_URL } from '../../common/CommonConstants';
import {toURL} from '../../reducers/util';
import { ICDNode } from './types/ICDNode';
import {CONFIG} from "../../util/config";

const treeURL = ICD10_TREE_URL;
const searchURL = ICD10_TREE_FILTER_URL;
const treeIpdnUrl = ICD10_IPDN_TREE_URL;
const searchIpdnUrl = ICD10_IPDN_TREE_FILTER_URL;

export const searchForIcd10Diagnosis = (value: string, useIpdn: boolean = false): Promise<ICDNode[]> => {
    const host = useIpdn ? searchIpdnUrl : searchURL;
    const url = toURL(`${host}${value}`, true);
    return doFetch(url);
} 

export const getChildDiagnosisBlock = (parentDiagnosisCode: string, useIpdn: boolean = false): Promise<ICDNode[]> => {
    const host = useIpdn ? treeIpdnUrl : treeURL;
    const url = toURL(`${host}?mode=children&parent=${parentDiagnosisCode}&query=${parentDiagnosisCode}`, true)
    return doFetch(url);
}

const doFetch = (url: string) => {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json',
        },
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    .then(results => results.json())
}